import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FooterComponent } from './common/pages/footer/footer.component';
import { HeaderComponent } from './common/pages/header/header.component';
import { SidebarComponent } from './common/pages/sidebar/sidebar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { EncrDecrService } from './_services/encode.decode.service';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LockComponent } from './lock/lock.component';
import { ProfileComponent } from './profile/profile.component';
import { AdminRightComponent } from './settings/admin-right/admin-right.component';
import { AdministratorComponent } from './settings/administrator/administrator.component';
import { PaginationComponent } from './common/widget/pagination/pagination.component';
import { ModuleMenuComponent } from './common/widget/module-menu/module-menu.component';
import { CountriesComponent } from './settings/countries/countries.component';
import { CurrenciesComponent } from './settings/currencies/currencies.component';
import { AreasComponent } from './settings/areas/areas.component';
import { DocumentTypeComponent } from './settings/document/document.component';
import { UserManageComponent } from './users/manage/manage.component';
import { UserKycComponent } from './users/kyc/kyc.component';
import { DetailsComponent } from './users/details/details.component';
import { PrintComponent } from './users/details/print/print.component';
import { IdentityDocumentComponent } from './settings/identity-document/identity-document.component';
import { DealslipComponent } from './dealslip/dealslip.component';
import { CrossExchangeRateComponent } from './cross-exchange-rate/cross-exchange-rate.component';
import { HrPeopleComponent } from './hr/people/people.component';
import { HrStaffDetailsComponent } from './hr/staff-details/staff-details.component';
import { TreasuryComponent } from './treasury/treasury.component';
import { FinancePlComponent } from './finance-pl/finance-pl.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    LoginComponent,
    LogoutComponent,
    ForgotPasswordComponent,
    LockComponent,
    ProfileComponent,
    AdminRightComponent,
    AdministratorComponent,
    PaginationComponent,
    ModuleMenuComponent,
    CountriesComponent,
    CurrenciesComponent,
    AreasComponent,
    DocumentTypeComponent,
    DealslipComponent,
    CrossExchangeRateComponent,
    UserManageComponent,
    UserKycComponent,
    DetailsComponent,
    PrintComponent,
    IdentityDocumentComponent,
    HrPeopleComponent,
    HrStaffDetailsComponent,
    TreasuryComponent,
    FinancePlComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), // ToastrModule added
  ],
  providers: [
    EncrDecrService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
